import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from './Modal'
import Button from './Button'

/**
 * Replacement for native `confirm()`. The browser dialog cannot be styled,
 * never goes through i18n and looks broken on mobile.
 */
export default function ConfirmDialog({
  open = true,
  title,
  message,
  confirmLabel,
  cancelLabel,
  tone = 'danger',
  busy,
  onConfirm,
  onCancel,
}: {
  open?: boolean
  title: ReactNode
  message?: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  tone?: 'danger' | 'primary'
  busy?: boolean
  onConfirm: () => void
  onCancel: () => void
}) {
  const { t } = useTranslation()
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={busy}>
            {cancelLabel ?? t('common.cancel')}
          </Button>
          <Button variant={tone} onClick={onConfirm} loading={busy}>
            {confirmLabel ?? t('common.confirm')}
          </Button>
        </>
      }
    >
      {message && <p className="text-sm text-gray-600">{message}</p>}
    </Modal>
  )
}
